// removed by extract-text-webpack-plugin
module.exports = {"info":"info___3duk-","message":"message___AQCxF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/CloseInfo/CloseInfo.less
// module id = 342
// module chunks = 0